/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {resetNotifications} from '@ion/applications/src/notifications/state';
import {retrieveReportOptions} from '@ion/applications/src/pages/reports/state';
import {error} from '@ion/core/src/logger/logger';
import {getAccount} from '@ion/core/src/services/Connect';
import {entityId} from '@ion/core/src/services/ConnectUtils';
import Sisense from '@ion/core/src/services/Sisense';
import {AccountLink} from '@ion/core/src/types/entities';
import changePage, {getRoute} from '@/routes/RouteDefinitions';
import Features, {ANALYTICS_REPORTS, DASHBOARD_PAGE, REPORTS} from '@/security/Features';
import {setPage} from '@/store/actions/nav';

export const TOGGLE_GLOBAL_GROUP_CHOOSER = 'TOGGLE_GLOBAL_GROUP_CHOOSER';
export const SET_GLOBAL_GROUP            = 'SET_GLOBAL_GROUP';
export const REFRESH_ACCOUNT_HIERARCHY   = 'REFRESH_ACCOUNT_HIERARCHY';
export const GLOBAL_GROUP_INITIALIZED    = 'GLOBAL_GROUP_INITIALIZED';

export const SOLOMON_ID                  = 'SOLOMON_ID';

/**
 * It will display showChangeGroup
 */
export const showChangeGroup = (value: boolean) => {
  return {type: TOGGLE_GLOBAL_GROUP_CHOOSER, value};
};

/**
 * It will setGlobalGroup
 */
export const setGlobalGroup = (group: AccountLink) => {
  return async(dispatch, getState) => {
    const {isRestricted, restrictedChanged} = Features.setCurrentAccount(group);
    const groupId = entityId(group.href);
    Sisense.setAccountId(groupId);
    try {
      const {solomonId} = await getAccount(groupId);
      dispatch({type: SOLOMON_ID, solomonId});
    } catch (err) {
      error(`Something went wrong while fetching the Solomon ID for account ${groupId}`, err);
      dispatch({type: SOLOMON_ID, solomonId: null});
    }
    dispatch({type: SET_GLOBAL_GROUP, group});
    if (Features.hasAny(DASHBOARD_PAGE, REPORTS, ANALYTICS_REPORTS)) {
      dispatch(retrieveReportOptions(true));
    }
    postSetGlobalGroup({dispatch, getState, restrictedChanged, isRestricted});
  };
};

/**
 * It will postSetGlobalGroup
 */
const postSetGlobalGroup = ({dispatch, getState, restrictedChanged, isRestricted}) => {
  // reset notification content based on the global group that user is selected.
  dispatch(resetNotifications());
  if (restrictedChanged) {
    if (isRestricted) {
      const route = Features.getDefaultRoute();
      dispatch(setPage(getRoute(route)));
      changePage(route);
    } else {
      const route = getState().nav.currentPage;
      dispatch(setPage(getRoute(route)));
      changePage(route);
    }
  }
};

/**
 * Refresh the account hierarchy tree on add/edit group(s) ...
 */
export const refreshAccountHierarchy = (accounts: AccountLink[]) => {
  return {type: REFRESH_ACCOUNT_HIERARCHY, accounts};
};
